<div class="waystar-dialog-container">
  <!-- Header -->
  <div class="header-container">
    <div class="header-left">
      <button mat-icon-button (click)="closeDialog()"><mat-icon>arrow_back</mat-icon></button>
      <span class="back-text" (click)="closeDialog()">Back to Queue</span>
      <div class="patient-title-area">
        <h2>{{ data?.selectedRecord?.name || 'Margaret Chen' }}</h2>
        <div class="subtitle">
          REF-{{ data?.selectedRecord?.referralID || '2026-00123' }} &bull;
          DOB: {{ data?.selectedRecord?.age || 'March 15, 1942' }} &bull;
          {{ data?.selectedRecord?.locationName || 'Sunrise Skilled Nursing' }}
        </div>
      </div>
    </div>
    <div class="header-right">
      <button mat-stroked-button *ngIf="hasAiDoc" class="btn-doc" (click)="showDocViewer = true"
              matTooltip="View source document">
        <mat-icon>picture_as_pdf</mat-icon> Document
      </button>
      <button mat-stroked-button>
        <mat-icon>phone</mat-icon> Launch Chatn.ai Call
      </button>
      <button mat-stroked-button (click)="persistVerification()" [disabled]="!waystarResponse">
        <mat-icon>save</mat-icon> Save
      </button>
      <button mat-stroked-button
              class="btn-accept"
              [disabled]="!waystarResponse || isUpdatingAcceptance || acceptanceStatus === 2"
              (click)="acceptVerification()">
        <mat-icon>check_circle</mat-icon>
        {{ acceptanceStatus === 2 ? 'Accepted' : 'Accept' }}
      </button>
      <button mat-stroked-button
              class="btn-reject"
              [disabled]="!waystarResponse || isUpdatingAcceptance || acceptanceStatus === 3"
              (click)="rejectVerification()">
        <mat-icon>cancel</mat-icon>
        {{ acceptanceStatus === 3 ? 'Rejected' : 'Reject' }}
      </button>
    </div>
  </div>

  <div class="header-bottom-bar">
    <span [class]="waystarFailure ? 'badge-inactive' : getStatusBadgeClass(parsedOutput?.FileStatusDescription)" *ngIf="waystarResponse">
      {{ waystarFailure ? 'Verification Failed' : (parsedOutput?.FileStatusDescription || 'Active') }}
    </span>
    <span *ngIf="acceptanceStatus" [class]="getAcceptanceBadgeClass()" class="acceptance-badge">
      <mat-icon style="font-size:13px;height:13px;width:13px;vertical-align:middle;">
        {{ acceptanceStatus === 2 ? 'check_circle' : acceptanceStatus === 3 ? 'cancel' : 'hourglass_empty' }}
      </mat-icon>
      {{ getAcceptanceLabel() }}
    </span>
    <span class="admit-info" *ngIf="data?.selectedRecord?.waystarVerifiedOn">
      Last Verified: {{ data.selectedRecord.waystarVerifiedOn | date:'medium' }}
    </span>
    <span class="assigned-info">Assigned to: Jane Doe</span>

    <!-- Provider on File — office-level default, inline edit (no popup). -->
    <div class="ws-provider-strip" [formGroup]="intakeForm" [class.editing]="isEditingProviderOnFile">
      <mat-icon class="ws-ps-icon">domain</mat-icon>
      <span class="ws-ps-title">Provider on file</span>
      <span *ngIf="providerOnFile" class="ws-provider-default-chip"><mat-icon>check</mat-icon> Default</span>

      <!-- View mode: details, or -- when nothing is on file yet -->
      <ng-container *ngIf="!isEditingProviderOnFile">
        <span class="ws-ps-item">
          <label>Provider</label>
          <b>{{ intakeForm.get('providerName')?.value || '--' }}</b>
        </span>
        <span class="ws-ps-item">
          <label>NPI</label>
          <b>{{ intakeForm.get('providerNpi')?.value || '--' }}</b>
        </span>
        <span class="ws-ps-item">
          <label>Tax ID</label>
          <b>{{ intakeForm.get('providerTaxId')?.value || '--' }}</b>
        </span>
        <span class="ws-ps-item">
          <label>PIN</label>
          <b>{{ intakeForm.get('providerPin')?.value || '--' }}</b>
        </span>
        <button type="button" class="ws-provider-link" (click)="editProviderOnFile()">
          <mat-icon>edit</mat-icon> {{ hasProviderDetails() ? 'Edit' : 'Add' }}
        </button>
      </ng-container>

      <!-- Inline add/edit mode -->
      <ng-container *ngIf="isEditingProviderOnFile">
        <input type="text" formControlName="providerName" class="ws-ps-input" placeholder="Provider Name">
        <input type="text" formControlName="providerNpi" class="ws-ps-input ws-ps-input-sm"
               placeholder="NPI" maxlength="10" inputmode="numeric" (input)="sanitizeDigits('providerNpi', 10)">
        <input type="text" formControlName="providerTaxId" class="ws-ps-input ws-ps-input-sm"
               placeholder="Tax ID" maxlength="9" inputmode="numeric" (input)="sanitizeDigits('providerTaxId', 9)">
        <input type="text" formControlName="providerPin" class="ws-ps-input ws-ps-input-sm"
               placeholder="PIN" maxlength="50">
        <button type="button" class="ws-provider-save-btn" [disabled]="isSavingProviderOnFile" (click)="saveProviderOnFile()">
          <span *ngIf="!isSavingProviderOnFile">Save</span>
          <mat-spinner *ngIf="isSavingProviderOnFile" diameter="14"></mat-spinner>
        </button>
        <button type="button" class="ws-provider-link" (click)="cancelProviderOnFileEdit()">
          <mat-icon>close</mat-icon>
        </button>
      </ng-container>
    </div>
  </div>

  <!-- Main Body -->
  <div class="main-content">
    <!-- Sidebar -->
    <div class="sidebar">
      <div class="sidebar-title">Sections</div>
      <ul class="section-list">
        <li *ngFor="let section of sections"
            [class.active]="activeSection === section"
            (click)="selectSection(section)">
          <mat-icon *ngIf="section === 'Intake Data'">description</mat-icon>
          <mat-icon *ngIf="section === 'Payer Stack'">layers</mat-icon>
          <mat-icon *ngIf="section === 'Coverage Detection'">manage_search</mat-icon>
          <mat-icon *ngIf="section === 'Electronic Verification'">verified</mat-icon>
          <mat-icon *ngIf="section === 'Manual Call Workflow'">phone_in_talk</mat-icon>
          <mat-icon *ngIf="section === 'Authorization'">security</mat-icon>
          <mat-icon *ngIf="section === 'Financial Summary'">attach_money</mat-icon>
          <mat-icon *ngIf="section === 'Coverage Details'">list_alt</mat-icon>
          <mat-icon *ngIf="section === 'Verification History'">history</mat-icon>
          <mat-icon *ngIf="section === 'Notes & Audit Trail'">speaker_notes</mat-icon>
          <span>{{ section }}</span>
          <span *ngIf="waystarResponse && (section === 'Electronic Verification' || section === 'Payer Stack' || section === 'Financial Summary' || section === 'Coverage Details')"
                class="section-data-dot"></span>
          <span *ngIf="coverageDetectionResults && section === 'Coverage Detection'"
                class="section-data-dot" style="background:#7c3aed;"></span>
        </li>
      </ul>
    </div>

    <!-- Content Area -->
    <div class="content-area" [class.content-area-flush]="activeSection === 'Intake Data' && hasAiDoc">

      <!-- ══════════════════════════════════════════════
           INTAKE DATA
      ══════════════════════════════════════════════ -->
      <div *ngIf="activeSection === 'Intake Data'"
           class="intake-data-section" [class.intake-data-split]="hasAiDoc" [formGroup]="intakeForm">

        <!-- ── INTAKE FORM pane (80%) ── -->
        <div class="intake-form-pane">
          <div class="intake-pane-header" *ngIf="hasAiDoc">
            <mat-icon>assignment</mat-icon><span>Intake Form</span>
          </div>
          <div class="intake-tab-content">

        <!-- ── Run eligibility check card ── -->
        <div class="ws-elig-card">
          <div class="ws-elig-card-head">
            <div class="ws-elig-card-icon"><mat-icon>fact_check</mat-icon></div>
            <div class="ws-elig-card-headtext">
              <div class="ws-elig-card-title">
                Run eligibility check
                <span class="ws-recommended-chip">Recommended</span>
              </div>
              <div class="ws-elig-card-sub">Required fields only &mdash; typically completed in under 30 seconds.</div>
            </div>
            <span class="ws-cost-chip" title="Cost per run"><strong>$0.25</strong>&nbsp;per check</span>
          </div>

          <div class="ws-elig-card-body">
            <div class="ws-group-row">
              <div class="ws-group-label">Patient Details</div>
              <div class="ws-required-note"><span class="req">*</span> Required</div>
            </div>
            <div class="ws-grid ws-grid-3">
            <div class="form-group">
              <label>First Name <span class="req">*</span></label>
              <input type="text" formControlName="subscriberFirstName" class="form-control" placeholder="First Name">
            </div>
            <div class="form-group">
              <label>Last Name <span class="req">*</span></label>
              <input type="text" formControlName="subscriberLastName" class="form-control" placeholder="Last Name">
            </div>
            <div class="form-group">
              <label>Date of Birth <span class="req">*</span></label>
              <mat-form-field appearance="outline" class="intake-datepicker">
                <input matInput [matDatepicker]="dobPicker" formControlName="dateOfBirth" placeholder="MM/DD/YYYY">
                <mat-datepicker-toggle matSuffix [for]="dobPicker"></mat-datepicker-toggle>
                <mat-datepicker #dobPicker></mat-datepicker>
              </mat-form-field>
            </div>
            </div><!-- /.ws-grid-3 (patient details) -->

            <div class="ws-group-label">Coverage Details</div>
            <div class="ws-grid ws-grid-payer">
              <div class="form-group">
                <label>Select Payer <span class="req">*</span></label>
                <button type="button" class="ws-payer-trigger"
                        [class.placeholder]="!getSelectedPayerName()"
                        (click)="openPayerPicker()">
                  <span class="ws-payer-trigger-text">{{ getSelectedPayerName() || 'Search &amp; select payer…' }}</span>
                  <mat-icon>unfold_more</mat-icon>
                </button>
              </div>
              <div class="form-group">
                <label>Subscriber / Member ID <span class="req">*</span></label>
                <input type="text" formControlName="subscriberId" class="form-control"
                       placeholder="As printed on the insurance card"
                       (input)="sanitizeNoSpaces('subscriberId')">
              </div>
            </div><!-- /.ws-grid-payer (coverage details) -->

            <!-- How the provider is identified to the payer on Run. Default is
                 Name + NPI; Tax ID is only sent when one of the Tax options is
                 chosen (Tax ID comes from the office Provider on File). -->
            <div class="ws-provider-id-mode">
              <span class="ws-pim-label">Send provider to payer as</span>
              <label class="ws-pim-opt">
                <input type="radio" formControlName="providerIdMode" value="npi">
                <span>Name + NPI</span>
              </label>
              <label class="ws-pim-opt">
                <input type="radio" formControlName="providerIdMode" value="name_tax">
                <span>Name + Tax ID</span>
              </label>
              <label class="ws-pim-opt ws-pim-opt-rare">
                <input type="radio" formControlName="providerIdMode" value="npi_tax">
                <span>Name + NPI + Tax ID</span>
                <span class="ws-pim-rare-tag">rare</span>
              </label>
              <span class="ws-pim-hint"
                    *ngIf="(intakeForm.get('providerIdMode')?.value === 'npi_tax' || intakeForm.get('providerIdMode')?.value === 'name_tax') && !intakeForm.get('providerTaxId')?.value">
                <mat-icon>info_outline</mat-icon> Add a Tax ID in Provider on file
              </span>
            </div>

            <!-- Optional patient details expander (made prominent so it isn't missed) -->
            <button type="button" class="ws-optional-toggle" [class.ws-optional-open]="showOptionalDetails"
                    (click)="showOptionalDetails = !showOptionalDetails">
              <span class="ws-optional-cta">
                {{ showOptionalDetails ? 'Hide' : 'Show' }}
                <mat-icon>{{ showOptionalDetails ? 'expand_less' : 'expand_more' }}</mat-icon>
              </span>
              <span class="ws-optional-textwrap">
                <span class="ws-optional-label">{{ showOptionalDetails ? 'Hide optional patient details' : 'Add more patient details' }}</span>
                <span class="ws-optional-hint">Optional — improves match accuracy (SSN, address, gender…)</span>
              </span>
            </button>

            <div class="ws-optional-panel" *ngIf="showOptionalDetails">
            <div class="ws-grid ws-grid-4">
            <div class="form-group">
              <label>Middle Name <span class="intake-optional">(optional)</span></label>
              <input type="text" formControlName="subscriberMiddleName" class="form-control" placeholder="Middle Name">
            </div>
            <div class="form-group">
              <label>Gender</label>
              <select formControlName="gender" class="form-control">
                <option value="">Select</option>
                <option value="M">Male</option>
                <option value="F">Female</option>
                <option value="U">Unknown</option>
              </select>
            </div>
            <div class="form-group">
              <label>SSN <span class="intake-optional">(123-45-6789 — improves match)</span></label>
              <input type="text" formControlName="ssn" class="form-control"
                     placeholder="123-45-6789" maxlength="11" inputmode="numeric"
                     (input)="formatSsnInput()">
              <div class="field-error" *ngIf="intakeForm.get('ssn')?.touched && intakeForm.get('ssn')?.hasError('pattern')">
                SSN must be 9 digits (123-45-6789)
              </div>
            </div>
            <div class="form-group">
              <label>MRN <span class="intake-optional">(improves match)</span></label>
              <input type="text" formControlName="medicalRecordNumber" class="form-control"
                     placeholder="As assigned by the facility EHR"
                     (input)="sanitizeNoSpaces('medicalRecordNumber')">
            </div>
            <div class="form-group full-width">
              <label>Street Address <span class="intake-optional">(improves match)</span></label>
              <input type="text" formControlName="address" class="form-control"
                     [class.field-invalid]="addressFieldMissing('address')"
                     placeholder="Street address only — city/state/ZIP below">
              <div class="field-error" *ngIf="addressFieldMissing('address')">Required to complete the address</div>
            </div>
            <div class="form-group">
              <label>City <span class="intake-optional">(improves match)</span></label>
              <input type="text" formControlName="city" class="form-control"
                     [class.field-invalid]="addressFieldMissing('city')" placeholder="City">
              <div class="field-error" *ngIf="addressFieldMissing('city')">Required to complete the address</div>
            </div>
            <div class="form-group">
              <label>State
                <span class="intake-optional intake-hint-help"
                      matTooltip="Waystar picks which payers to search by the patient's state: the state Medicaid program and its managed-care plans, regional Blue Cross plans, and the right Medicare contractor. Without a state, Coverage Discovery can only search the national payers, so state-program coverage may be missed. It also feeds the patient match score.">
                  (drives coverage search <mat-icon class="intake-hint-icon">info_outline</mat-icon>)
                </span>
              </label>
              <input type="text" formControlName="state" class="form-control"
                     [class.field-invalid]="addressFieldMissing('state')"
                     placeholder="e.g. KY" maxlength="2" (input)="formatStateInput()">
              <div class="field-error" *ngIf="addressFieldMissing('state')">Required to complete the address</div>
              <div class="field-error" *ngIf="intakeForm.get('state')?.touched && intakeForm.get('state')?.hasError('pattern')">
                State must be a 2-letter code
              </div>
            </div>
            <div class="form-group">
              <label>ZIP <span class="intake-optional">(improves match)</span></label>
              <input type="text" formControlName="zip" class="form-control"
                     [class.field-invalid]="addressFieldMissing('zip')"
                     placeholder="40212 or 40212-1234" maxlength="10" inputmode="numeric"
                     (input)="formatZipInput()">
              <div class="field-error" *ngIf="addressFieldMissing('zip')">Required to complete the address</div>
              <div class="field-error" *ngIf="intakeForm.get('zip')?.touched && intakeForm.get('zip')?.hasError('pattern')">
                ZIP must be 5 digits (or ZIP+4)
              </div>
            </div>
            </div><!-- /.ws-grid-4 (optional fields) -->
            </div><!-- /.ws-optional-panel -->
          </div><!-- /.ws-elig-card-body -->

          <!-- Address all-or-nothing reminder — pinned at the bottom of the card so
               it never pushes the form fields around when it toggles. -->
          <div class="address-group-note" *ngIf="isAddressPartial()">
            <mat-icon>info_outline</mat-icon>
            <span>Enter the <strong>complete</strong> address (Street, City, State, ZIP) or leave all four empty.</span>
          </div>

          <div class="ws-elig-card-footer">
            <div class="ws-secure-note">
              <mat-icon>lock</mat-icon>
              <span><strong>Secure eligibility check</strong> &middot; Sent directly to Waystar</span>
            </div>
            <div class="ws-footer-actions">
              <div class="panel-hint" *ngIf="!intakeForm.get('payerId')?.value">
                <mat-icon>info_outline</mat-icon> Select a payer to enable
              </div>
              <button class="intake-btn intake-btn-blue ws-run-btn"
                      [disabled]="!intakeForm.get('payerId')?.value || isLoading"
                      (click)="runWaystarCheck()">
                <span *ngIf="!isLoading" class="intake-btn-inner">
                  <mat-icon>play_arrow</mat-icon>
                  Run Waystar check
                </span>
                <span *ngIf="isLoading" class="intake-btn-inner">
                  <mat-spinner diameter="18"></mat-spinner> Running…
                </span>
              </button>
            </div>
          </div>
        </div><!-- /.ws-elig-card -->

        <!-- ── Coverage Discovery fallback — hidden for now (showCoverageDiscovery = false)
             but kept fully intact so it can be re-enabled without rework. ── -->
        <div class="intake-action-stack" *ngIf="showCoverageDiscovery">

          <!-- Secondary fallback divider -->
          <div class="intake-fallback-divider">
            <span>Insurance unknown?</span>
          </div>

          <!-- SECONDARY — Coverage Discovery (expensive fallback, $4.50) -->
          <div class="intake-panel intake-panel-detect intake-panel-secondary">
            <div class="panel-header">
              <div class="panel-icon-wrap panel-icon-purple">
                <mat-icon>manage_search</mat-icon>
              </div>
              <div class="panel-header-text">
                <div class="panel-title">Coverage Discovery</div>
                <div class="panel-subtitle">Use only when the patient's payer is unknown or can't be verified</div>
              </div>
              <span class="cost-chip cost-chip-expensive" title="Cost per run — ~18× a standard check">
                <mat-icon>warning_amber</mat-icon> $4.50 / run
              </span>
            </div>

            <div class="panel-body panel-body-compact">
              <div class="panel-detect-info">
                Coverage Discovery searches Medicare, Medicaid &amp; major commercial plans for unknown insurance.
                It's about <strong>18× more expensive</strong> than a standard Waystar Check, so use it only as a fallback.
              </div>
              <div class="panel-hint" *ngIf="coverageDetectionResults">
                <mat-icon style="color:#16a34a;">check_circle</mat-icon>
                {{ coverageDetectionResults.coverages?.length || 0 }} coverage(s) found — see Coverage Detection tab
              </div>
            </div>

            <div class="panel-footer">
              <button class="intake-btn intake-btn-secondary"
                      (click)="attemptDetectCoverage()"
                      [disabled]="isDetectingCoverage">
                <span *ngIf="!isDetectingCoverage" class="intake-btn-inner">
                  <mat-icon>manage_search</mat-icon>
                  Run Coverage Discovery
                  <span class="btn-cost-tag btn-cost-tag-warn">$4.50</span>
                </span>
                <span *ngIf="isDetectingCoverage" class="intake-btn-inner">
                  <mat-spinner diameter="18"></mat-spinner> Searching Waystar network…
                </span>
              </button>
            </div>
          </div>

        </div>
          </div><!-- /.intake-tab-content (form) -->
        </div><!-- /.intake-form-pane -->

        <!-- ── AI DATA pane (20%) — read-only reference ── -->
        <div class="intake-aidata-pane" *ngIf="hasAiDoc">
          <div class="intake-pane-tabs">
            <button type="button" [class.active]="activeAiTab === 'ai'" (click)="selectAiTab('ai')">
              <mat-icon>smart_toy</mat-icon> AI Data
              <mat-icon *ngIf="aiDataFields.length" class="intake-tab-tick">check_circle</mat-icon>
            </button>
            <button type="button" [class.active]="activeAiTab === 'kv'" (click)="selectAiTab('kv')">
              <mat-icon>list_alt</mat-icon> Key Value
            </button>
          </div>

          <!-- AI Data tab: system/doc field mapping from the AI tool -->
          <div class="intake-tab-content intake-ai-data" *ngIf="activeAiTab === 'ai'">
            <div *ngIf="isLoadingAiData" class="intake-ai-loading">
              <mat-spinner diameter="22"></mat-spinner><span>Loading AI data…</span>
            </div>
            <table *ngIf="!isLoadingAiData && aiDataFields.length" class="intake-ai-table">
              <tr><th>Field</th><th>Value</th><th></th></tr>
              <tr *ngFor="let f of aiDataFields">
                <td class="intake-ai-field" [matTooltip]="f.fieldName">{{ f.fieldName }}</td>
                <td class="intake-ai-value">
                  <button *ngIf="f.value" type="button" class="intake-ai-value-btn"
                          matTooltip="Find this value in the document"
                          (click)="openAiValueInDoc(f)">
                    <span class="intake-ai-value-text">{{ f.value }}</span>
                    <mat-icon class="intake-ai-find-icon">search</mat-icon>
                  </button>
                  <span *ngIf="!f.value" class="intake-ai-value-empty">—</span>
                </td>
                <td class="intake-ai-copy">
                  <button mat-icon-button type="button" matTooltip="Copy value"
                          [disabled]="!f.value" (click)="copyAiValue(f.value)">
                    <mat-icon>content_copy</mat-icon>
                  </button>
                </td>
              </tr>
            </table>
            <div *ngIf="!isLoadingAiData && !aiDataFields.length" class="intake-ai-empty">
              <mat-icon>smart_toy</mat-icon>
              <p>No AI-extracted data for this document.</p>
            </div>
          </div>

          <!-- Key Value tab: raw OCR key/value pairs (Key Value Mapping source) -->
          <div class="intake-tab-content intake-ai-data intake-kv-pane" *ngIf="activeAiTab === 'kv'">
            <div class="intake-kv-search">
              <mat-icon>search</mat-icon>
              <input type="text" placeholder="Search key or value…"
                     [value]="kvSearch" (input)="onKvSearch($event)">
              <button mat-icon-button type="button" *ngIf="kvSearch"
                      matTooltip="Clear search" (click)="kvSearch = ''">
                <mat-icon>close</mat-icon>
              </button>
            </div>
            <div *ngIf="isLoadingKeyValues" class="intake-ai-loading">
              <mat-spinner diameter="22"></mat-spinner><span>Loading key/value pairs…</span>
            </div>
            <div class="intake-kv-list" *ngIf="!isLoadingKeyValues && keyValueData.length">
              <table class="intake-ai-table">
                <tr><th>Key</th><th>Value</th><th></th></tr>
                <tr *ngFor="let kv of filteredKeyValues()">
                  <td class="intake-ai-field" [matTooltip]="kv.key">{{ kv.key }}</td>
                  <td class="intake-ai-value">
                    <button *ngIf="kv.value" type="button" class="intake-ai-value-btn"
                            matTooltip="Find this value in the document"
                            (click)="openAiValueInDoc({ fieldName: kv.key, value: kv.value })">
                      <span class="intake-ai-value-text">{{ kv.value }}</span>
                      <mat-icon class="intake-ai-find-icon">search</mat-icon>
                    </button>
                    <span *ngIf="!kv.value" class="intake-ai-value-empty">—</span>
                  </td>
                  <td class="intake-ai-copy">
                    <button mat-icon-button type="button" matTooltip="Copy value"
                            [disabled]="!kv.value" (click)="copyAiValue(kv.value)">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                  </td>
                </tr>
              </table>
              <div *ngIf="filteredKeyValues().length === 0" class="intake-kv-nomatch">
                No pairs match "{{ kvSearch }}".
              </div>
            </div>
            <div *ngIf="!isLoadingKeyValues && !keyValueData.length" class="intake-ai-empty">
              <mat-icon>list_alt</mat-icon>
              <p>No key/value pairs extracted for this document.</p>
            </div>
          </div>
        </div><!-- /.intake-aidata-pane -->

      </div>

      <!-- ══════════════════════════════════════════════
           PAYER STACK
      ══════════════════════════════════════════════ -->
      <div *ngIf="activeSection === 'Payer Stack'" class="section-wrapper">
        <h3>Payer Stack</h3>

        <div *ngIf="isLoading" class="loading-state">
          <div class="spinner-lg"></div>
          <p>Running Waystar verification...</p>
        </div>

        <div *ngIf="!waystarResponse && !isLoading" class="no-response-state">
          <mat-icon>layers</mat-icon>
          <p>No payer data yet. Run a Waystar Check from Intake Data to populate this section.</p>
          <button class="btn-outline" (click)="activeSection = 'Intake Data'">Go to Intake Data</button>
        </div>

        <div *ngIf="waystarResponse && !isLoading">
          <div class="carrier-bar">
            <span class="carrier-name">{{ parsedOutput?.CarrierName }}</span>
            <span [class]="getStatusBadgeClass(parsedOutput?.FileStatusDescription)">
              {{ parsedOutput?.FileStatusDescription }}
            </span>
            <span class="inquiry-id">Inquiry ID: {{ waystarResponse?.InquiryId }}</span>
            <span *ngIf="getEffectiveDate()" class="eff-date">
              Effective: {{ formatApiDate(getEffectiveDate()) }}
            </span>
          </div>

          <div class="plans-grid">
            <div *ngFor="let plan of plans; let i = index" class="plan-card">
              <div class="plan-card-header">
                <span class="plan-type-badge">{{ plan.Name || plan.InsurancePlan }}</span>
                <span [class]="getStatusBadgeClass(plan.FileStatusDescription)">{{ plan.FileStatusDescription }}</span>
              </div>
              <div class="plan-card-body">
                <div class="plan-detail" *ngIf="plan.InsurancePlanName">
                  <label>Plan Name</label><div>{{ plan.InsurancePlanName }}</div>
                </div>
                <div class="plan-detail" *ngIf="plan.ActiveDate || plan.PatientEffectiveBenefitDate">
                  <label>Effective Date</label>
                  <div>{{ plan.ActiveDate || plan.PatientEffectiveBenefitDate }}</div>
                </div>
                <div class="plan-detail" *ngIf="plan.DeductibleInNetwork">
                  <label>Deductible (In-Network)</label><div>${{ plan.DeductibleInNetwork }}</div>
                </div>
                <div class="plan-detail" *ngIf="plan.DeductibleOutNetwork">
                  <label>Deductible (Out-of-Network)</label><div>${{ plan.DeductibleOutNetwork }}</div>
                </div>
                <div class="plan-detail" *ngIf="plan.PlanBinDed">
                  <label>Plan Deductible</label><div>${{ plan.PlanBinDed }}</div>
                </div>
                <div class="plan-detail" *ngIf="plan.PlanBinDedRem">
                  <label>Deductible Remaining</label><div class="value-highlight">${{ plan.PlanBinDedRem }}</div>
                </div>
                <div class="plan-detail" *ngIf="plan.PlanBinOopRem">
                  <label>OOP Max Remaining</label><div class="value-highlight">${{ plan.PlanBinOopRem }}</div>
                </div>
                <div class="plan-detail" *ngIf="plan.CoInsuranceInNetwork">
                  <label>Co-Insurance (In)</label>
                  <div>{{ plan.CoInsuranceInNetwork | percent:'1.0-0' }} patient share</div>
                </div>
                <div class="plan-detail" *ngIf="plan.HospitalInpatientBinCovgPerc">
                  <label>Hospital Inpatient Coverage</label><div>{{ plan.HospitalInpatientBinCovgPerc }}</div>
                </div>
                <div class="plan-detail" *ngIf="plan.Oi1Name">
                  <label>Supplemental Insurer</label><div>{{ plan.Oi1Name }}</div>
                </div>
                <div class="plan-detail" *ngIf="plan.Oi1Phone">
                  <label>Insurer Phone</label><div>{{ plan.Oi1Phone }}</div>
                </div>
                <div class="plan-detail" *ngIf="plan.PlanBinDed && plan.ErBinCovgPerc">
                  <label>ER Coverage</label><div>{{ plan.ErBinCovgPerc }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Other Insurance -->
          <div *ngIf="getOtherInsurance().length > 0" class="section-sub-card">
            <h4>Other Insurance on File</h4>
            <div *ngFor="let oi of getOtherInsurance()" class="info-grid">
              <div class="info-item"><label>Payer Name</label><div>{{ oi.PayerName || oi.Name }}</div></div>
              <div class="info-item"><label>Plan Code</label><div>{{ oi.PlanCode }}</div></div>
              <div class="info-item" *ngIf="oi.Phone"><label>Phone</label><div>{{ oi.Phone }}</div></div>
              <div class="info-item" *ngIf="oi.Address1">
                <label>Address</label><div>{{ oi.Address1 }}, {{ oi.City }}, {{ oi.State }} {{ oi.Zip }}</div>
              </div>
              <div class="info-item" *ngIf="oi.Cob"><label>COB Date</label><div>{{ oi.Cob }}</div></div>
              <div class="info-item" *ngIf="oi.InsuranceTypeCode"><label>Insurance Type</label><div>{{ oi.InsuranceTypeCode }}</div></div>
            </div>
          </div>
        </div>
      </div>

      <!-- ══════════════════════════════════════════════
           COVERAGE DETECTION
      ══════════════════════════════════════════════ -->
      <div *ngIf="activeSection === 'Coverage Detection'" class="section-wrapper">
        <h3>Coverage Detection Results</h3>
        <p class="section-desc">
          Coverages automatically discovered by Waystar. Use <strong>Detect Coverage</strong> on the Intake tab to run a new search.
        </p>

        <!-- Detecting in progress -->
        <div *ngIf="isDetectingCoverage" class="loading-state">
          <div class="spinner-lg"></div>
          <p>Searching Waystar network — this may take 15–30 seconds…</p>
        </div>

        <!-- No Results yet -->
        <div *ngIf="!isDetectingCoverage && !coverageDetectionResults" class="cd-empty-state">
          <mat-icon>policy</mat-icon>
          <p>Run detection to automatically discover active insurance coverage for this patient.</p>
          <button class="btn-outline" (click)="activeSection = 'Intake Data'">Go to Intake Data</button>
        </div>

        <!-- Results -->
        <div *ngIf="coverageDetectionResults" class="cd-results">
          <div class="cd-results-header">
            <span class="cd-status-badge"
                  [class.cd-badge-found]="coverageDetectionResults.coverageFound"
                  [class.cd-badge-notfound]="!coverageDetectionResults.coverageFound">
              {{ coverageDetectionResults.coverageFound ? 'Coverage Found' : 'No Coverage' }}
            </span>
            <span class="cd-meta">
              {{ coverageDetectionResults.coverages?.length || 0 }} result(s) &bull;
              {{ coverageDetectionResults.elapsedSeconds }}s
            </span>
          </div>

          <!-- No coverage message -->
          <div *ngIf="!coverageDetectionResults.coverageFound && (!coverageDetectionResults.coverages || coverageDetectionResults.coverages.length === 0)"
               class="cd-no-coverage">
            <mat-icon>info_outline</mat-icon>
            <div>
              <strong>No active coverage detected.</strong>
              <p>Try adding SSN or address in the Intake tab to improve match accuracy, then run Detect Coverage again.</p>
              <p *ngIf="coverageDetectionResults.failReason" class="cd-fail-reason">
                Waystar reason: {{ coverageDetectionResults.failReason }}
              </p>
            </div>
          </div>

          <!-- Coverage cards -->
          <div *ngFor="let cov of coverageDetectionResults.coverages" class="cd-coverage-card">
            <div class="cd-card-header">
              <div class="cd-payer-info">
                <span class="cd-payer-name">{{ cov.payerName || 'Unknown Payer' }}</span>
                <span class="cd-payer-id" *ngIf="cov.payerId">({{ cov.payerId }})</span>
              </div>
              <div class="cd-badges">
                <span class="cd-active-badge" [class.cd-active]="cov.isActive" [class.cd-inactive]="!cov.isActive">
                  {{ cov.isActive ? 'Active' : 'Inactive' }}
                </span>
                <span class="cd-match-badge" [class]="getMatchScoreClass(cov.matchScore)">
                  {{ getMatchScoreLabel(cov.matchScore) }}
                </span>
              </div>
            </div>

            <div class="cd-card-body">
              <div class="cd-detail-grid">
                <div class="cd-detail-item" *ngIf="cov.memberId">
                  <label>Member ID</label><span>{{ cov.memberId }}</span>
                </div>
                <div class="cd-detail-item" *ngIf="cov.groupNumber">
                  <label>Group #</label><span>{{ cov.groupNumber }}</span>
                </div>
                <div class="cd-detail-item" *ngIf="cov.planName">
                  <label>Plan</label><span>{{ cov.planName }}</span>
                </div>
                <div class="cd-detail-item" *ngIf="cov.effectiveDate">
                  <label>Effective</label><span>{{ formatCoverageDate(cov.effectiveDate) }}</span>
                </div>
                <div class="cd-detail-item" *ngIf="cov.terminationDate">
                  <label>Term Date</label><span>{{ formatCoverageDate(cov.terminationDate) }}</span>
                </div>
              </div>
            </div>

            <div class="cd-card-footer" *ngIf="cov.isActive">
              <button mat-stroked-button class="cd-use-btn" (click)="useDetectedCoverage(cov)">
                <mat-icon>arrow_forward</mat-icon>
                Run Full Eligibility
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- ══════════════════════════════════════════════
           ELECTRONIC VERIFICATION
      ══════════════════════════════════════════════ -->
      <div *ngIf="activeSection === 'Electronic Verification'" class="section-wrapper">
        <h3>Electronic Verification</h3>

        <div *ngIf="isLoading" class="loading-state">
          <div class="spinner-lg"></div>
          <p>Running Waystar verification...</p>
        </div>

        <div *ngIf="!waystarResponse && !isLoading" class="no-response-state">
          <mat-icon>verified</mat-icon>
          <p>No verification data yet. Run a Waystar Check from Intake Data.</p>
          <button class="btn-outline" (click)="activeSection = 'Intake Data'">Go to Intake Data</button>
        </div>

        <div *ngIf="waystarResponse && !isLoading">
          <!-- Payer rejection banner — tells the user exactly what failed and
               what to do next, so a failed run is never mistaken for success. -->
          <div class="ev-failure-banner" *ngIf="waystarFailure">
            <mat-icon>error_outline</mat-icon>
            <div class="ev-failure-text">
              <strong>Verification could not be completed{{ waystarFailure.code ? ' (payer code ' + waystarFailure.code + ')' : '' }}.</strong>
              <p>{{ waystarFailure.reason }}</p>
              <p class="ev-failure-hint" *ngIf="waystarFailure.hint">
                <mat-icon>lightbulb_outline</mat-icon> {{ waystarFailure.hint }}
              </p>
              <ul class="ev-failure-alerts" *ngIf="waystarFailure.alerts?.length">
                <li *ngFor="let a of waystarFailure.alerts">{{ a }}</li>
              </ul>
              <button class="btn-outline sm" (click)="activeSection = 'Intake Data'">
                <mat-icon style="font-size:14px;height:14px;width:14px;">edit</mat-icon>
                Back to Intake Data
              </button>
            </div>
          </div>

          <!-- Status banner -->
          <div class="status-banner">
            <span [class]="getStatusBadgeClass(parsedOutput?.FileStatusDescription)">
              {{ parsedOutput?.FileStatusDescription }}
            </span>
            <span class="banner-item"><strong>Carrier:</strong> {{ parsedOutput?.CarrierName }}</span>
            <span class="banner-item"><strong>Member ID:</strong> {{ parsedOutput?.MemberId }}</span>
            <span class="banner-item"><strong>Inquiry ID:</strong> {{ waystarResponse?.InquiryId }}</span>
            <span class="banner-item" *ngIf="getEffectiveDate()">
              <strong>Effective:</strong> {{ formatApiDate(getEffectiveDate()) }}
            </span>
          </div>

          <!-- Tabs -->
          <div class="ev-tabs">
            <button [class.active]="activeEvTab === 'summary'" (click)="activeEvTab = 'summary'">
              <mat-icon>person</mat-icon> Verification Summary
            </button>
            <button [class.active]="activeEvTab === 'parsed'" (click)="activeEvTab = 'parsed'">
              <mat-icon>article</mat-icon> Parsed Output
            </button>
            <button [class.active]="activeEvTab === 'raw'" (click)="activeEvTab = 'raw'">
              <mat-icon>code</mat-icon> Raw JSON Response
            </button>
          </div>

          <!-- ── Summary Tab ── -->
          <div *ngIf="activeEvTab === 'summary'">

            <!-- Subscriber / Member -->
            <div class="ev-card">
              <div class="ev-card-title">
                <mat-icon>person</mat-icon> Subscriber / Member
              </div>
              <div class="info-grid">
                <div class="info-item"><label>First Name</label><div>{{ subscriber?.First || '-' }}</div></div>
                <div class="info-item"><label>Last Name</label><div>{{ subscriber?.Last || '-' }}</div></div>
                <div class="info-item"><label>Date of Birth</label><div>{{ subscriber?.Dob || '-' }}</div></div>
                <div class="info-item"><label>Member ID</label><div>{{ subscriber?.MemberId || '-' }}</div></div>
                <div class="info-item"><label>Relationship</label><div>{{ parsedOutput?.SubscriberRelationship || '-' }}</div></div>
                <div class="info-item"><label>Coverage Status</label>
                  <div><span [class]="getStatusBadgeClass(parsedOutput?.FileStatusDescription)">{{ parsedOutput?.FileStatusDescription }}</span></div>
                </div>
              </div>
            </div>

            <!-- Carrier -->
            <div class="ev-card">
              <div class="ev-card-title"><mat-icon>business</mat-icon> Carrier / Payer</div>
              <div class="info-grid">
                <div class="info-item"><label>Carrier Name</label><div>{{ parsedOutput?.CarrierName || '-' }}</div></div>
                <div class="info-item"><label>Carrier Code</label><div>{{ parsedOutput?.CarrierCode || '-' }}</div></div>
                <div class="info-item" *ngIf="parsedOutput?.CarrierAddress1">
                  <label>Address</label>
                  <div>{{ parsedOutput.CarrierAddress1 }}, {{ parsedOutput.CarrierCity }}, {{ parsedOutput.CarrierState }} {{ parsedOutput.CarrierZip }}</div>
                </div>
                <div class="info-item" *ngIf="parsedOutput?.ClaimsInfo?.Name">
                  <label>Claims Submission</label><div>{{ parsedOutput.ClaimsInfo.Name }}</div>
                </div>
                <div class="info-item" *ngIf="parsedOutput?.ClaimsInfo?.Address1">
                  <label>Claims Address</label>
                  <div>{{ parsedOutput.ClaimsInfo.Address1 }}, {{ parsedOutput.ClaimsInfo.City }}, {{ parsedOutput.ClaimsInfo.State }} {{ parsedOutput.ClaimsInfo.Zip }}</div>
                </div>
                <div class="info-item"><label>Plan Name</label><div>{{ parsedOutput?.PlanName || plans[0]?.InsurancePlanName || '-' }}</div></div>
              </div>
            </div>

            <!-- Plans summary -->
            <div class="ev-card" *ngIf="plans.length > 0">
              <div class="ev-card-title"><mat-icon>layers</mat-icon> Active Plans</div>
              <div class="plans-summary-list">
                <div *ngFor="let plan of plans" class="plan-summary-row">
                  <span class="plan-type-badge sm">{{ plan.Name || plan.InsurancePlan }}</span>
                  <span class="plan-label">{{ getServiceTypeName(plan.Name || plan.InsurancePlan) }}</span>
                  <span [class]="getStatusBadgeClass(plan.FileStatusDescription)" style="font-size:11px;">{{ plan.FileStatusDescription }}</span>
                  <span class="plan-date" *ngIf="plan.ActiveDate">Eff: {{ plan.ActiveDate }}</span>
                  <span class="plan-ded" *ngIf="plan.DeductibleInNetwork">Ded: ${{ plan.DeductibleInNetwork }}</span>
                </div>
              </div>
            </div>

            <!-- Other Insurance -->
            <div class="ev-card" *ngIf="getOtherInsurance().length > 0">
              <div class="ev-card-title"><mat-icon>account_balance</mat-icon> Other Insurance on File</div>
              <div *ngFor="let oi of getOtherInsurance()">
                <div class="info-grid">
                  <div class="info-item"><label>Plan Name</label><div>{{ oi.PayerName || oi.Name }}</div></div>
                  <div class="info-item"><label>Plan Code</label><div>{{ oi.PlanCode }}</div></div>
                  <div class="info-item" *ngIf="oi.Phone"><label>Phone</label><div>{{ oi.Phone }}</div></div>
                  <div class="info-item" *ngIf="oi.Address1">
                    <label>Address</label><div>{{ oi.Address1 }}, {{ oi.City }}, {{ oi.State }}</div>
                  </div>
                  <div class="info-item" *ngIf="oi.Cob"><label>COB Date</label><div>{{ oi.Cob }}</div></div>
                </div>
              </div>
            </div>

            <!-- Medicaid plan notes -->
            <div class="ev-card" *ngIf="getMedicaidProviders().length > 0">
              <div class="ev-card-title"><mat-icon>local_hospital</mat-icon> Medicaid Plan Details</div>
              <div *ngFor="let mp of getMedicaidProviders()" class="info-grid">
                <div class="info-item"><label>Plan Name</label><div>{{ mp.Name }}</div></div>
                <div class="info-item"><label>Effective Date</label><div>{{ formatApiDate(mp.EffDate) }}</div></div>
                <div class="info-item" *ngIf="mp.Msg"><label>Notes</label><div>{{ mp.Msg }}</div></div>
              </div>
            </div>
          </div>

          <!-- ── Parsed Output Tab (structured, friendly view) ── -->
          <div *ngIf="activeEvTab === 'parsed'" class="parsed-v2">

            <div *ngIf="!parsedOutput" class="no-response-state">
              <mat-icon>article</mat-icon>
              <p>No parsed output in the response.</p>
            </div>

            <ng-container *ngIf="parsedOutput">

              <!-- 1. Status / Identity Header -->
              <div class="po-card po-status-card">
                <div class="po-status-main">
                  <span [class]="getStatusBadgeClass(parsedOutput.FileStatusDescription)" class="lg-badge">
                    {{ parsedOutput.FileStatusDescription || 'UNKNOWN' }}
                  </span>
                  <div class="po-status-info">
                    <h4>{{ parsedOutput.CarrierName || 'Unknown Carrier' }}</h4>
                    <div class="po-muted">
                      <span *ngIf="parsedOutput.CarrierCode">Code: <strong>{{ parsedOutput.CarrierCode }}</strong></span>
                      <span *ngIf="parsedOutput.MemberId"> · Member ID: <strong>{{ parsedOutput.MemberId }}</strong></span>
                    </div>
                  </div>
                </div>
                <div class="po-status-meta">
                  <div *ngIf="getEffectiveDate()">
                    <label>Effective Date</label>
                    <div>{{ formatApiDate(getEffectiveDate()) }}</div>
                  </div>
                  <div *ngIf="waystarResponse?.InquiryId">
                    <label>Inquiry ID</label>
                    <div>{{ waystarResponse.InquiryId }}</div>
                  </div>
                  <div *ngIf="parsedOutput.PlanName">
                    <label>Plan Name</label>
                    <div>{{ parsedOutput.PlanName }}</div>
                  </div>
                  <div *ngIf="parsedOutput.HasMedicarePassportadvantage !== undefined">
                    <label>Medicare Passport</label>
                    <div>{{ parsedOutput.HasMedicarePassportadvantage ? 'Yes' : 'No' }}</div>
                  </div>
                </div>
              </div>

              <!-- 2. Subscriber & Patient -->
              <div class="po-card">
                <div class="po-card-title"><mat-icon>person</mat-icon> Subscriber &amp; Patient</div>
                <div class="po-two-col">
                  <div class="po-person-block">
                    <div class="po-block-title">Subscriber</div>
                    <div class="info-grid">
                      <div class="info-item"><label>First Name</label><div>{{ subscriber?.First || '—' }}</div></div>
                      <div class="info-item"><label>Last Name</label><div>{{ subscriber?.Last || '—' }}</div></div>
                      <div class="info-item"><label>Date of Birth</label><div>{{ subscriber?.Dob || '—' }}</div></div>
                      <div class="info-item"><label>Member ID</label><div>{{ subscriber?.MemberId || '—' }}</div></div>
                      <div class="info-item"><label>Relationship</label><div>{{ parsedOutput.SubscriberRelationship || '—' }}</div></div>
                    </div>
                  </div>

                  <div class="po-person-block po-same" *ngIf="isPatientSameAsSubscriber()">
                    <div class="po-block-title">Patient</div>
                    <div class="po-same-msg">
                      <mat-icon>check_circle</mat-icon>
                      <span>Patient is the same as subscriber</span>
                    </div>
                  </div>
                  <div class="po-person-block" *ngIf="parsedOutput.Patient && !isPatientSameAsSubscriber()">
                    <div class="po-block-title">Patient</div>
                    <div class="info-grid">
                      <div class="info-item"><label>First Name</label><div>{{ parsedOutput.Patient.First || '—' }}</div></div>
                      <div class="info-item"><label>Last Name</label><div>{{ parsedOutput.Patient.Last || '—' }}</div></div>
                      <div class="info-item"><label>Date of Birth</label><div>{{ parsedOutput.Patient.Dob || '—' }}</div></div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 3. Carrier Address & Claims Info -->
              <div *ngIf="parsedOutput.CarrierAddress1 || parsedOutput.ClaimsInfo" class="po-card">
                <div class="po-card-title"><mat-icon>business</mat-icon> Carrier &amp; Claims</div>
                <div class="po-two-col">
                  <div *ngIf="parsedOutput.CarrierAddress1" class="po-person-block">
                    <div class="po-block-title">Carrier Address</div>
                    <div class="po-address">
                      {{ parsedOutput.CarrierAddress1 }}<br>
                      {{ parsedOutput.CarrierCity }}, {{ parsedOutput.CarrierState }} {{ parsedOutput.CarrierZip }}
                    </div>
                  </div>
                  <div *ngIf="parsedOutput.ClaimsInfo" class="po-person-block">
                    <div class="po-block-title">Claims Submission</div>
                    <div class="info-grid">
                      <div class="info-item" *ngIf="parsedOutput.ClaimsInfo.Name">
                        <label>Name</label><div>{{ parsedOutput.ClaimsInfo.Name }}</div>
                      </div>
                      <div class="info-item" *ngIf="parsedOutput.ClaimsInfo.Address1">
                        <label>Address</label>
                        <div>{{ parsedOutput.ClaimsInfo.Address1 }}<br>
                          {{ parsedOutput.ClaimsInfo.City }}, {{ parsedOutput.ClaimsInfo.State }} {{ parsedOutput.ClaimsInfo.Zip }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 4. Date References (if multiple) -->
              <div *ngIf="parsedOutput.Dtps && parsedOutput.Dtps.length > 1" class="po-card">
                <div class="po-card-title">
                  <mat-icon>event</mat-icon> Date References
                  <span class="po-count">{{ parsedOutput.Dtps.length }}</span>
                </div>
                <table class="po-mini-table">
                  <thead><tr><th>Type</th><th>Date</th></tr></thead>
                  <tbody>
                    <tr *ngFor="let d of parsedOutput.Dtps">
                      <td><code>{{ d.Type }}</code></td>
                      <td>{{ formatApiDate(d.Date) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- 5. Plans -->
              <div *ngIf="plans.length > 0" class="po-card">
                <div class="po-card-title">
                  <mat-icon>layers</mat-icon> Active Plans
                  <span class="po-count">{{ plans.length }}</span>
                </div>
                <div class="po-plans-list">
                  <div *ngFor="let plan of plans; let i = index" class="po-plan-row">
                    <div class="po-plan-head">
                      <span class="plan-type-badge">{{ plan.Name || plan.InsurancePlan }}</span>
                      <span class="po-plan-name">
                        {{ plan.InsurancePlanName || getServiceTypeName(plan.Name || plan.InsurancePlan) }}
                      </span>
                      <span [class]="getStatusBadgeClass(plan.FileStatusDescription)">
                        {{ plan.FileStatusDescription }}
                      </span>
                    </div>
                    <div class="po-plan-body info-grid">
                      <div *ngFor="let f of getPlanEntries(plan)" class="info-item">
                        <label>{{ f.label }}</label>
                        <div [class.hl]="f.isHighlight">{{ f.value }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 6. Benefits accordion -->
              <div *ngIf="getBenefitsList().length > 0" class="po-card">
                <div class="po-card-title">
                  <mat-icon>fact_check</mat-icon> Benefits by Service Type
                  <span class="po-count">{{ getBenefitsList().length }}</span>
                </div>

                <div class="po-benefits-toolbar">
                  <div class="po-search">
                    <mat-icon>search</mat-icon>
                    <input type="text"
                           placeholder="Search by code or service (e.g. pharmacy, 30, dental)..."
                           [value]="benefitSearch"
                           (input)="onBenefitSearch($event)">
                  </div>
                  <button class="btn-outline sm" (click)="expandAllBenefits()">
                    <mat-icon style="font-size:14px;height:14px;width:14px;">unfold_more</mat-icon> Expand All
                  </button>
                  <button class="btn-outline sm" (click)="collapseAllBenefits()">
                    <mat-icon style="font-size:14px;height:14px;width:14px;">unfold_less</mat-icon> Collapse All
                  </button>
                </div>

                <div class="po-benefits-list">
                  <div *ngFor="let b of filteredBenefits()"
                       class="po-benefit-item"
                       [class.expanded]="isBenefitExpanded(b.planType)">
                    <div class="po-benefit-head" (click)="toggleBenefit(b.planType)">
                      <mat-icon class="chev">
                        {{ isBenefitExpanded(b.planType) ? 'expand_more' : 'chevron_right' }}
                      </mat-icon>
                      <span class="code-badge">{{ b.planType }}</span>
                      <span class="po-benefit-name">{{ b.name }}</span>
                      <span *ngIf="b.ind?.InsuranceType" class="po-benefit-type">
                        {{ b.ind.InsuranceType }}
                      </span>
                      <span *ngIf="b.ind?.CoverageStatus"
                            [class]="getStatusBadgeClass(b.ind.CoverageStatus)">
                        {{ b.ind.CoverageStatus }}
                      </span>
                      <span class="po-benefit-summary">{{ getBenefitSummary(b) }}</span>
                    </div>

                    <div *ngIf="isBenefitExpanded(b.planType)" class="po-benefit-body">
                      <div *ngIf="b.ind" class="po-level-block">
                        <div class="po-level-title"><span class="level-badge ind">IND</span> Individual</div>
                        <ng-container *ngTemplateOutlet="benefitDetailTpl; context: { d: b.ind }"></ng-container>
                      </div>
                      <div *ngIf="b.fam" class="po-level-block">
                        <div class="po-level-title"><span class="level-badge fam">FAM</span> Family</div>
                        <ng-container *ngTemplateOutlet="benefitDetailTpl; context: { d: b.fam }"></ng-container>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="filteredBenefits().length === 0" class="po-empty-list">
                    No service types match "{{ benefitSearch }}".
                  </div>
                </div>
              </div>

              <!-- 7. Other Insurance -->
              <div *ngIf="getOtherInsurance().length > 0" class="po-card">
                <div class="po-card-title">
                  <mat-icon>account_balance</mat-icon> Other Insurance
                  <span class="po-count">{{ getOtherInsurance().length }}</span>
                </div>
                <div *ngFor="let oi of getOtherInsurance()" class="po-oi-item">
                  <div class="po-oi-head">
                    <strong>{{ oi.PayerName || oi.Name }}</strong>
                    <span *ngIf="oi.PlanCode" class="code-badge">{{ oi.PlanCode }}</span>
                  </div>
                  <div class="info-grid">
                    <div class="info-item" *ngIf="oi.Phone"><label>Phone</label><div>{{ oi.Phone }}</div></div>
                    <div class="info-item" *ngIf="oi.Address1">
                      <label>Address</label>
                      <div>{{ oi.Address1 }}<br>{{ oi.City }}, {{ oi.State }} {{ oi.Zip }}</div>
                    </div>
                    <div class="info-item" *ngIf="oi.Cob"><label>COB Date</label><div>{{ oi.Cob }}</div></div>
                    <div class="info-item" *ngIf="oi.PlanType">
                      <label>Plan Type</label>
                      <div>{{ oi.PlanType }} · {{ getServiceTypeName(oi.PlanType) }}</div>
                    </div>
                    <div class="info-item" *ngIf="oi.InsuranceTypeCode">
                      <label>Insurance Type</label><div>{{ oi.InsuranceTypeCode }}</div>
                    </div>
                    <div class="info-item" *ngIf="oi.PlanQ"><label>Plan Q</label><div>{{ oi.PlanQ }}</div></div>
                    <div class="info-item" *ngIf="oi.OtherInsuranceId">
                      <label>Other Insurance ID</label><div>{{ oi.OtherInsuranceId }}</div>
                    </div>
                    <div class="info-item" *ngIf="oi.Ref02"><label>Ref 02</label><div>{{ oi.Ref02 }}</div></div>
                    <div class="info-item" *ngIf="oi.Eb01"><label>EB01</label><div>{{ oi.Eb01 }}</div></div>
                  </div>
                </div>
              </div>

              <!-- 8. Medicaid Plan Details -->
              <div *ngIf="getMedicaidProviders().length > 0" class="po-card">
                <div class="po-card-title">
                  <mat-icon>local_hospital</mat-icon> Medicaid Plan Details
                  <span class="po-count">{{ getMedicaidProviders().length }}</span>
                </div>
                <div *ngFor="let mp of getMedicaidProviders()" class="info-grid">
                  <div class="info-item"><label>Plan Name</label><div>{{ mp.Name }}</div></div>
                  <div class="info-item" *ngIf="mp.EffDate">
                    <label>Effective Date</label><div>{{ formatApiDate(mp.EffDate) }}</div>
                  </div>
                  <div class="info-item" *ngIf="mp.PlanType">
                    <label>Plan Type</label>
                    <div>{{ mp.PlanType }} · {{ getServiceTypeName(mp.PlanType) }}</div>
                  </div>
                  <div class="info-item" *ngIf="mp.Msg"><label>Notes</label><div>{{ mp.Msg }}</div></div>
                </div>
              </div>

              <!-- 9. Catch-all: any field not displayed above -->
              <div *ngIf="hasOtherParsedFields()" class="po-card">
                <div class="po-card-title">
                  <mat-icon>more_horiz</mat-icon> Additional Fields
                </div>
                <p class="po-card-desc">Any data from the response not categorized above is shown here so nothing is missed.</p>
                <ng-container *ngTemplateOutlet="renderObjectTpl; context: { obj: getOtherParsedFieldsObj(), depth: 0 }"></ng-container>
              </div>

            </ng-container>
          </div>

          <!-- Benefit detail template (used by benefits accordion) -->
          <ng-template #benefitDetailTpl let-d="d">
            <div class="po-detail-grid" *ngIf="hasNetworkSummary(d)">
              <div *ngIf="d.BinCovgPerc !== undefined || d.BonCovgPerc !== undefined" class="po-mini-card">
                <label>Coverage</label>
                <div *ngIf="d.BinCovgPerc !== undefined"><span class="muted">In-Ntwk:</span> <strong>{{ d.BinCovgPerc }}</strong></div>
                <div *ngIf="d.BonCovgPerc !== undefined"><span class="muted">Out-Ntwk:</span> <strong>{{ d.BonCovgPerc }}</strong></div>
              </div>
              <div *ngIf="d.BinDed !== undefined || d.BonDed !== undefined || d.BinDedRem !== undefined || d.BonDedRem !== undefined" class="po-mini-card">
                <label>Deductible</label>
                <div *ngIf="d.BinDed !== undefined"><span class="muted">In-Ntwk:</span> <strong>{{ formatMoney(d.BinDed) }}</strong></div>
                <div *ngIf="d.BinDedRem !== undefined"><span class="muted">In-Ntwk Rem:</span> <strong>{{ formatMoney(d.BinDedRem) }}</strong></div>
                <div *ngIf="d.BonDed !== undefined"><span class="muted">Out-Ntwk:</span> <strong>{{ formatMoney(d.BonDed) }}</strong></div>
                <div *ngIf="d.BonDedRem !== undefined"><span class="muted">Out-Ntwk Rem:</span> <strong>{{ formatMoney(d.BonDedRem) }}</strong></div>
              </div>
              <div *ngIf="d.BinOop !== undefined || d.BinOopRem !== undefined" class="po-mini-card">
                <label>Out-of-Pocket Max</label>
                <div *ngIf="d.BinOop !== undefined"><span class="muted">Total:</span> <strong>{{ formatMoney(d.BinOop) }}</strong></div>
                <div *ngIf="d.BinOopRem !== undefined"><span class="muted">Remaining:</span> <strong>{{ formatMoney(d.BinOopRem) }}</strong></div>
              </div>
              <div *ngIf="d.BinCopay1 !== undefined" class="po-mini-card">
                <label>Co-Pay</label>
                <div><strong>{{ formatMoney(d.BinCopay1) }}</strong></div>
              </div>
              <div *ngIf="d.PlanType" class="po-mini-card">
                <label>Plan Type</label>
                <div><code>{{ d.PlanType }}</code> · {{ getServiceTypeName(d.PlanType) }}</div>
              </div>
              <div *ngIf="d.InsuranceType" class="po-mini-card">
                <label>Insurance Type</label>
                <div><code>{{ d.InsuranceType }}</code></div>
              </div>
            </div>

            <!-- CovgPercs -->
            <div *ngIf="d.CovgPercs && d.CovgPercs.length > 0" class="po-sub-section">
              <div class="po-sub-title">Coverage Percentages ({{ d.CovgPercs.length }})</div>
              <table class="po-mini-table">
                <thead><tr><th>Value</th><th>Network</th><th>Effective</th></tr></thead>
                <tbody>
                  <tr *ngFor="let c of d.CovgPercs">
                    <td><strong>{{ c.Value || '—' }}</strong></td>
                    <td>{{ formatNetFlag(c.NetFlag) }}</td>
                    <td>
                      <div *ngFor="let dtp of c.Dtps" class="muted-small">{{ dtp.Type }}: {{ formatApiDate(dtp.Date) }}</div>
                      <span *ngIf="!c.Dtps || c.Dtps.length === 0" class="muted">—</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Copays -->
            <div *ngIf="d.Copays && d.Copays.length > 0" class="po-sub-section">
              <div class="po-sub-title">Co-Pays ({{ d.Copays.length }})</div>
              <table class="po-mini-table">
                <thead><tr><th>Value</th><th>Time Qualifier</th><th>Network</th></tr></thead>
                <tbody>
                  <tr *ngFor="let c of d.Copays">
                    <td><strong>{{ formatMoney(c.Value) }}</strong></td>
                    <td><code>{{ c.Tq || '—' }}</code></td>
                    <td>{{ formatNetFlag(c.NetFlag) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Deds -->
            <div *ngIf="d.Deds && d.Deds.length > 0" class="po-sub-section">
              <div class="po-sub-title">Deductibles ({{ d.Deds.length }})</div>
              <table class="po-mini-table">
                <thead><tr><th>Plan</th><th>Value</th><th>Network</th><th>Effective</th></tr></thead>
                <tbody>
                  <tr *ngFor="let d2 of d.Deds">
                    <td>
                      <span *ngIf="d2.Name" class="plan-type-badge sm">{{ d2.Name }}</span>
                      <span *ngIf="!d2.Name" class="muted">—</span>
                    </td>
                    <td><strong>{{ formatMoney(d2.Value) }}</strong></td>
                    <td>{{ formatNetFlag(d2.NetFlag) }}</td>
                    <td>
                      <span *ngIf="d2.EffDate">{{ formatApiDate(d2.EffDate) }}</span>
                      <div *ngFor="let dtp of d2.Dtps" class="muted-small">{{ dtp.Type }}: {{ formatApiDate(dtp.Date) }}</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- DedRems -->
            <div *ngIf="d.DedRems && d.DedRems.length > 0" class="po-sub-section">
              <div class="po-sub-title">Deductible Remaining ({{ d.DedRems.length }})</div>
              <table class="po-mini-table">
                <thead><tr><th>Plan</th><th>Remaining</th><th>Network</th></tr></thead>
                <tbody>
                  <tr *ngFor="let d2 of d.DedRems">
                    <td>
                      <span *ngIf="d2.Name" class="plan-type-badge sm">{{ d2.Name }}</span>
                      <span *ngIf="!d2.Name" class="muted">—</span>
                    </td>
                    <td><strong>{{ formatMoney(d2.Value) }}</strong></td>
                    <td>{{ formatNetFlag(d2.NetFlag) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Oops -->
            <div *ngIf="d.Oops && d.Oops.length > 0" class="po-sub-section">
              <div class="po-sub-title">Out-of-Pocket Max ({{ d.Oops.length }})</div>
              <table class="po-mini-table">
                <thead><tr><th>Value</th><th>Network</th></tr></thead>
                <tbody>
                  <tr *ngFor="let o of d.Oops">
                    <td><strong>{{ formatMoney(o.Value) }}</strong></td>
                    <td>{{ formatNetFlag(o.NetFlag) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- OopRems -->
            <div *ngIf="d.OopRems && d.OopRems.length > 0" class="po-sub-section">
              <div class="po-sub-title">OOP Remaining ({{ d.OopRems.length }})</div>
              <table class="po-mini-table">
                <thead><tr><th>Remaining</th><th>Network</th></tr></thead>
                <tbody>
                  <tr *ngFor="let o of d.OopRems">
                    <td><strong>{{ formatMoney(o.Value) }}</strong></td>
                    <td>{{ formatNetFlag(o.NetFlag) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Days -->
            <div *ngIf="d.Days && d.Days.length > 0" class="po-sub-section">
              <div class="po-sub-title">Coverage Days ({{ d.Days.length }})</div>
              <table class="po-mini-table">
                <thead><tr><th>Network</th><th>Note</th></tr></thead>
                <tbody>
                  <tr *ngFor="let day of d.Days">
                    <td>{{ formatNetFlag(day.NetFlag) }}</td>
                    <td>{{ day.Msg || '—' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Dtps -->
            <div *ngIf="d.Dtps && d.Dtps.length > 0" class="po-sub-section">
              <div class="po-sub-title">Date References ({{ d.Dtps.length }})</div>
              <table class="po-mini-table">
                <thead><tr><th>Type</th><th>Date</th></tr></thead>
                <tbody>
                  <tr *ngFor="let dt of d.Dtps">
                    <td><code>{{ dt.Type }}</code></td>
                    <td>{{ formatApiDate(dt.Date) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Descriptions -->
            <div *ngIf="d.Descriptions && d.Descriptions.length > 0" class="po-sub-section">
              <div class="po-sub-title">Plan Coverage Descriptions ({{ d.Descriptions.length }})</div>
              <div *ngFor="let desc of d.Descriptions" class="po-desc-item">
                <strong>{{ desc.PlanCoverageDescription || 'Description' }}</strong>
                <div *ngIf="desc.InsuranceType" class="muted-small">Type: {{ desc.InsuranceType }}</div>
                <div *ngIf="desc.Msg" class="muted-small">{{ desc.Msg }}</div>
                <div *ngFor="let dtp of desc.Dtps" class="muted-small">{{ dtp.Type }}: {{ formatApiDate(dtp.Date) }}</div>
              </div>
            </div>

            <!-- Notes -->
            <div *ngIf="(d.PlanNotes && d.PlanNotes.length > 0) || d.BinNotes || d.BinDaysMsg" class="po-sub-section">
              <div class="po-sub-title">Notes</div>
              <ul class="po-notes">
                <li *ngIf="d.BinNotes">{{ d.BinNotes }}</li>
                <li *ngIf="d.BinDaysMsg">{{ d.BinDaysMsg }}</li>
                <li *ngFor="let n of d.PlanNotes">{{ n.Msg }}</li>
              </ul>
            </div>

            <!-- Any other unrecognized fields on this benefit detail -->
            <div *ngIf="getBenefitOtherFields(d).length > 0" class="po-sub-section">
              <div class="po-sub-title po-sub-title-muted">Other Fields</div>
              <div class="po-other-fields">
                <div *ngFor="let f of getBenefitOtherFields(d)" class="po-other-row">
                  <span class="po-other-key">{{ f.label }}</span>
                  <span class="po-other-val">
                    <ng-container *ngTemplateOutlet="renderValueTpl; context: { value: f.value, depth: 0 }"></ng-container>
                  </span>
                </div>
              </div>
            </div>
          </ng-template>

          <!-- Recursive templates for parsed output rendering -->
          <ng-template #renderObjectTpl let-obj="obj" let-depth="depth">
            <div class="po-object" [attr.data-depth]="depth">
              <div *ngFor="let entry of objectEntries(obj)" class="po-row">
                <div class="po-key">{{ formatKeyLabel(entry.key) }}</div>
                <div class="po-value">
                  <ng-container
                    *ngTemplateOutlet="renderValueTpl; context: { value: entry.value, depth: depth + 1 }">
                  </ng-container>
                </div>
              </div>
            </div>
          </ng-template>

          <ng-template #renderValueTpl let-value="value" let-depth="depth">
            <ng-container [ngSwitch]="getValueType(value)">
              <span *ngSwitchCase="'primitive'" class="po-primitive">{{ value }}</span>
              <span *ngSwitchCase="'empty'" class="po-empty">—</span>

              <div *ngSwitchCase="'array'" class="po-array">
                <div *ngFor="let item of value; let i = index" class="po-array-item">
                  <div class="po-array-index">[{{ i }}]</div>
                  <div class="po-array-content">
                    <ng-container
                      *ngTemplateOutlet="renderValueTpl; context: { value: item, depth: depth + 1 }">
                    </ng-container>
                  </div>
                </div>
              </div>

              <div *ngSwitchCase="'object'" class="po-nested">
                <ng-container
                  *ngTemplateOutlet="renderObjectTpl; context: { obj: value, depth: depth }">
                </ng-container>
              </div>
            </ng-container>
          </ng-template>

          <!-- ── Raw JSON Tab ── -->
          <div *ngIf="activeEvTab === 'raw'" class="raw-json-viewer">
            <div class="raw-toolbar">
              <span class="raw-label">Full API Response &mdash; Inquiry {{ waystarResponse?.InquiryId }}</span>
              <button class="btn-outline sm" (click)="copyJson()">
                <mat-icon style="font-size:14px;height:14px;width:14px;">content_copy</mat-icon> Copy JSON
              </button>
            </div>
            <pre class="json-pre">{{ getFormattedJson() }}</pre>
          </div>
        </div>
      </div>

      <!-- ══════════════════════════════════════════════
           FINANCIAL SUMMARY
      ══════════════════════════════════════════════ -->
      <div *ngIf="activeSection === 'Financial Summary'" class="section-wrapper">
        <h3>Financial Summary</h3>

        <div *ngIf="isLoading" class="loading-state">
          <div class="spinner-lg"></div>
          <p>Running Waystar verification...</p>
        </div>

        <div *ngIf="!waystarResponse && !isLoading" class="no-response-state">
          <mat-icon>attach_money</mat-icon>
          <p>No financial data yet. Run a Waystar Check from Intake Data.</p>
          <button class="btn-outline" (click)="activeSection = 'Intake Data'">Go to Intake Data</button>
        </div>

        <div *ngIf="waystarResponse && !isLoading">
          <div class="carrier-bar">
            <span class="carrier-name">{{ parsedOutput?.CarrierName }}</span>
            <span [class]="getStatusBadgeClass(parsedOutput?.FileStatusDescription)">{{ parsedOutput?.FileStatusDescription }}</span>
            <span class="inquiry-id">Plan: {{ parsedOutput?.PlanName || getPrimaryPlan()?.InsurancePlanName || getPrimaryPlan()?.Name || '-' }}</span>
          </div>

          <ng-container *ngIf="getFinancialSummary() as fin">
            <div class="fin-section-title">Health Benefit Plan (Service Type 30)</div>
            <table class="fin-table">
              <thead>
                <tr>
                  <th>Benefit</th>
                  <th>Individual</th>
                  <th>Family</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Deductible (Total)</td>
                  <td [class.value-dash]="fin.indDeductible === '-'">{{ fin.indDeductible }}</td>
                  <td [class.value-dash]="fin.famDeductible === '-'">{{ fin.famDeductible }}</td>
                </tr>
                <tr class="highlight-row">
                  <td>Deductible (Remaining)</td>
                  <td [class.value-dash]="fin.indDeductibleRem === '-'">{{ fin.indDeductibleRem }}</td>
                  <td [class.value-dash]="fin.famDeductibleRem === '-'">{{ fin.famDeductibleRem }}</td>
                </tr>
                <tr>
                  <td>Out-of-Pocket Maximum</td>
                  <td [class.value-dash]="fin.indOop === '-'">{{ fin.indOop }}</td>
                  <td [class.value-dash]="fin.famOop === '-'">{{ fin.famOop }}</td>
                </tr>
                <tr class="highlight-row">
                  <td>Out-of-Pocket (Remaining)</td>
                  <td [class.value-dash]="fin.indOopRem === '-'">{{ fin.indOopRem }}</td>
                  <td [class.value-dash]="fin.famOopRem === '-'">{{ fin.famOopRem }}</td>
                </tr>
                <tr>
                  <td>Co-Insurance (In-Network)</td>
                  <td colspan="2" [class.value-dash]="fin.coInsIn === '-'">{{ fin.coInsIn }}</td>
                </tr>
                <tr class="highlight-row">
                  <td>Co-Insurance (Out-of-Network)</td>
                  <td colspan="2" [class.value-dash]="fin.coInsOut === '-'">{{ fin.coInsOut }}</td>
                </tr>
                <tr>
                  <td>Co-Pay (Primary Service)</td>
                  <td colspan="2" [class.value-dash]="fin.copay === '-'">{{ fin.copay }}</td>
                </tr>
              </tbody>
            </table>

            <!-- MA/MB deductible breakdown if present -->
            <ng-container *ngIf="getBenefit('30') as b30">
              <div *ngIf="b30.IND?.Deds?.length > 0" class="fin-section-title" style="margin-top:24px;">
                Plan-Level Deductible Breakdown
              </div>
              <table *ngIf="b30.IND?.Deds?.length > 0" class="fin-table">
                <thead>
                  <tr><th>Plan</th><th>Deductible</th><th>Remaining</th></tr>
                </thead>
                <tbody>
                  <tr *ngFor="let ded of b30.IND?.Deds">
                    <td><span class="plan-type-badge sm">{{ ded.Name || '-' }}</span></td>
                    <td>${{ ded.Value }}</td>
                    <td>
                      <ng-container *ngFor="let rem of b30.IND?.DedRems">
                        <span *ngIf="rem.Name === ded.Name">${{ rem.Value }}</span>
                      </ng-container>
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-container>
          </ng-container>
        </div>
      </div>

      <!-- ══════════════════════════════════════════════
           COVERAGE DETAILS  (new section)
      ══════════════════════════════════════════════ -->
      <div *ngIf="activeSection === 'Coverage Details'" class="section-wrapper">
        <h3>Coverage Details</h3>
        <p class="section-desc">Full benefit breakdown by service type from the Waystar response.</p>

        <div *ngIf="isLoading" class="loading-state">
          <div class="spinner-lg"></div>
          <p>Running Waystar verification...</p>
        </div>

        <div *ngIf="!waystarResponse && !isLoading" class="no-response-state">
          <mat-icon>list_alt</mat-icon>
          <p>No coverage data yet. Run a Waystar Check from Intake Data.</p>
          <button class="btn-outline" (click)="activeSection = 'Intake Data'">Go to Intake Data</button>
        </div>

        <div *ngIf="waystarResponse && !isLoading">
          <div class="carrier-bar">
            <span class="carrier-name">{{ parsedOutput?.CarrierName }}</span>
            <span [class]="getStatusBadgeClass(parsedOutput?.FileStatusDescription)">{{ parsedOutput?.FileStatusDescription }}</span>
            <span class="inquiry-id">{{ getBenefitsList().length }} service types</span>
          </div>

          <div class="coverage-table-wrapper">
            <table class="coverage-table">
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Service Type</th>
                  <th>Level</th>
                  <th>Status</th>
                  <th>Plan</th>
                  <th>Co-Insurance</th>
                  <th>Deductible</th>
                  <th>Co-Pay</th>
                  <th>Notes</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let b of getBenefitsList()">
                  <!-- IND row -->
                  <tr *ngIf="b.ind">
                    <td><span class="code-badge">{{ b.planType }}</span></td>
                    <td>{{ b.name }}</td>
                    <td><span class="level-badge ind">IND</span></td>
                    <td>
                      <span [class]="getStatusBadgeClass(b.ind.CoverageStatus)">
                        {{ b.ind.CoverageStatus || 'Active' }}
                      </span>
                    </td>
                    <td>{{ b.ind.InsuranceType || '-' }}</td>
                    <td>{{ getCoveragePercent(b.ind) }}</td>
                    <td>{{ b.ind.BinDed !== undefined ? ('$' + b.ind.BinDed) : '-' }}</td>
                    <td>{{ b.ind.BinCopay1 !== undefined ? ('$' + b.ind.BinCopay1) : '-' }}</td>
                    <td class="notes-cell">
                      <span *ngIf="b.ind.BinNotes">{{ b.ind.BinNotes }}</span>
                      <span *ngIf="getPlanNoteMsg(b.ind)">{{ getPlanNoteMsg(b.ind) }}</span>
                      <span *ngIf="b.ind.BinDaysMsg">{{ b.ind.BinDaysMsg }}</span>
                    </td>
                  </tr>
                  <!-- FAM row -->
                  <tr *ngIf="b.fam" class="fam-row">
                    <td><span class="code-badge">{{ b.planType }}</span></td>
                    <td>{{ b.name }}</td>
                    <td><span class="level-badge fam">FAM</span></td>
                    <td>—</td>
                    <td>—</td>
                    <td>-</td>
                    <td>{{ b.fam.BinDed !== undefined ? ('$' + b.fam.BinDed) : '-' }}</td>
                    <td>-</td>
                    <td></td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- ══════════════════════════════════════════════
           PLACEHOLDER SECTIONS
      ══════════════════════════════════════════════ -->
      <!-- ══════════════════════════════════════════════
           VERIFICATION HISTORY
      ══════════════════════════════════════════════ -->
      <div *ngIf="activeSection === 'Verification History'" class="section-wrapper">
        <h3>Verification History</h3>
        <p class="section-desc">All past Waystar verifications for this referral, newest first. Click a record to expand it or load it into the viewer.</p>

        <!-- Loading -->
        <div *ngIf="isLoadingHistory" class="loading-state">
          <div class="spinner-lg"></div>
          <p>Loading history...</p>
        </div>

        <!-- Empty -->
        <div *ngIf="!isLoadingHistory && historyRecords.length === 0" class="no-response-state">
          <mat-icon>history</mat-icon>
          <p>No verification history found for this referral.</p>
          <button class="btn-outline" (click)="activeSection = 'Intake Data'">Go to Intake Data</button>
        </div>

        <!-- History list + detail panel -->
        <div *ngIf="!isLoadingHistory && historyRecords.length > 0" class="history-layout">

          <!-- Timeline list -->
          <div class="history-list">
            <div *ngFor="let rec of historyRecords; let i = index"
                 class="history-item"
                 [class.history-item-selected]="selectedHistoryRecord?.historyID === rec.historyID"
                 (click)="selectHistoryRecord(rec)">
              <div class="history-item-dot" [class]="getHistoryStatusClass(rec.fileStatus)"></div>
              <div class="history-item-body">
                <div class="history-item-header">
                  <span class="history-carrier">{{ rec.carrierName || '—' }}</span>
                  <span [class]="getHistoryStatusClass(rec.fileStatus)" style="font-size:11px;padding:2px 8px;">
                    {{ rec.fileStatus === '1' ? 'Active' : (rec.fileStatus || '—') }}
                  </span>
                </div>
                <div class="history-item-meta">
                  <mat-icon style="font-size:13px;height:13px;width:13px;vertical-align:middle;">schedule</mat-icon>
                  {{ formatHistoryDate(rec.verifiedOn) }}
                  <span *ngIf="rec.inquiryId" class="history-inquiry">· Inquiry #{{ rec.inquiryId }}</span>
                </div>
              </div>
              <mat-icon class="history-chev">
                {{ selectedHistoryRecord?.historyID === rec.historyID ? 'expand_more' : 'chevron_right' }}
              </mat-icon>
            </div>
          </div>

          <!-- Detail panel -->
          <div *ngIf="selectedHistoryRecord" class="history-detail">
            <div class="history-detail-header">
              <div>
                <div class="history-carrier" style="font-size:16px;font-weight:600;">
                  {{ selectedHistoryRecord.carrierName || '—' }}
                </div>
                <div class="history-item-meta">
                  {{ formatHistoryDate(selectedHistoryRecord.verifiedOn) }}
                  <span *ngIf="selectedHistoryRecord.inquiryId"> · Inquiry #{{ selectedHistoryRecord.inquiryId }}</span>
                </div>
              </div>
              <button class="btn-primary" (click)="loadHistoryIntoViewer(selectedHistoryRecord)">
                <mat-icon>open_in_new</mat-icon>
                View Full Response
              </button>
            </div>

            <!-- Intake snapshot -->
            <div *ngIf="selectedHistoryRecord._intake" class="history-snapshot-card">
              <div class="history-snapshot-title"><mat-icon>description</mat-icon> Intake Snapshot</div>
              <div class="info-grid">
                <div class="info-item"><label>Payer ID</label><div>{{ selectedHistoryRecord._intake.payerId || '—' }}</div></div>
                <div class="info-item"><label>Subscriber</label><div>{{ selectedHistoryRecord._intake.subscriberFirstName }} {{ selectedHistoryRecord._intake.subscriberLastName }}</div></div>
                <div class="info-item"><label>Date of Birth</label><div>{{ selectedHistoryRecord._intake.dateOfBirth || '—' }}</div></div>
                <div class="info-item"><label>Subscriber ID</label><div>{{ selectedHistoryRecord._intake.subscriberId || '—' }}</div></div>
                <div class="info-item"><label>Provider NPI</label><div>{{ selectedHistoryRecord._intake.providerNpi || '—' }}</div></div>
                <div class="info-item"><label>Provider Tax ID</label><div>{{ selectedHistoryRecord._intake.providerTaxId || '—' }}</div></div>
              </div>
            </div>

            <!-- Response snapshot -->
            <div *ngIf="selectedHistoryRecord._response?.ParsedOutput as po" class="history-snapshot-card">
              <div class="history-snapshot-title"><mat-icon>verified</mat-icon> Verification Snapshot</div>
              <div class="info-grid">
                <div class="info-item">
                  <label>Coverage Status</label>
                  <div><span [class]="getStatusBadgeClass(po.FileStatusDescription)">{{ po.FileStatusDescription || '—' }}</span></div>
                </div>
                <div class="info-item"><label>Carrier</label><div>{{ po.CarrierName || '—' }}</div></div>
                <div class="info-item"><label>Member ID</label><div>{{ po.MemberId || '—' }}</div></div>
                <div class="info-item"><label>Plan Name</label><div>{{ getHistoryPlanName(po) }}</div></div>
                <div class="info-item" *ngIf="po.Subscriber">
                  <label>Subscriber Name</label>
                  <div>{{ po.Subscriber.First }} {{ po.Subscriber.Last }}</div>
                </div>
                <div class="info-item" *ngIf="po.Subscriber?.Dob">
                  <label>DOB on File</label><div>{{ po.Subscriber.Dob }}</div>
                </div>
              </div>

              <!-- Quick financials -->
              <div *ngIf="getHistoryBenefit30(po) as b30" class="history-financials">
                <div class="history-fin-item">
                  <label>Deductible (IND)</label>
                  <div>{{ b30.IND?.BinDed !== undefined ? ('$' + b30.IND.BinDed) : '—' }}</div>
                </div>
                <div class="history-fin-item">
                  <label>Deductible Remaining</label>
                  <div class="val-highlight">{{ b30.IND?.BinDedRem !== undefined ? ('$' + b30.IND.BinDedRem) : '—' }}</div>
                </div>
                <div class="history-fin-item">
                  <label>OOP Remaining</label>
                  <div class="val-highlight">{{ b30.IND?.BinOopRem !== undefined ? ('$' + b30.IND.BinOopRem) : '—' }}</div>
                </div>
              </div>
            </div>

            <div *ngIf="!selectedHistoryRecord._response" class="po-empty-list" style="margin-top:12px;">
              Response data could not be parsed.
            </div>
          </div>

        </div>
      </div>

      <!-- ══════════════════════════════════════════════
           NOTES & AUDIT TRAIL
      ══════════════════════════════════════════════ -->
      <div *ngIf="activeSection === 'Notes & Audit Trail'" class="section-wrapper">
        <h3>Notes &amp; Audit Trail</h3>
        <p class="section-desc">Add notes for this verification and review the full audit trail of activity.</p>

        <div class="notes-layout">

          <!-- ── Left: Notes ── -->
          <div class="notes-panel">
            <div class="notes-panel-title"><mat-icon>speaker_notes</mat-icon> Notes</div>

            <!-- Add note form -->
            <div class="note-compose">
              <textarea
                class="note-textarea"
                [(ngModel)]="newNoteText"
                [maxlength]="NOTE_MAX_LENGTH"
                placeholder="Add a note... (e.g. Called Aetna on 5/8 – rep confirmed active coverage)"
                rows="4">
              </textarea>
              <div class="note-compose-footer">
                <span class="note-char-count" [class.note-char-warn]="newNoteText.length > NOTE_MAX_LENGTH - 100">
                  {{ newNoteText.length }} / {{ NOTE_MAX_LENGTH }}
                </span>
                <button class="btn-primary"
                        (click)="submitNote()"
                        [disabled]="isSubmittingNote || !newNoteText.trim()">
                  <span *ngIf="!isSubmittingNote"><mat-icon>send</mat-icon> Add Note</span>
                  <span *ngIf="isSubmittingNote"><span class="spinner-sm"></span> Saving...</span>
                </button>
              </div>
            </div>

            <!-- Notes list -->
            <div *ngIf="isLoadingNotes" class="loading-state" style="padding:24px 0;">
              <div class="spinner-lg"></div>
              <p>Loading notes...</p>
            </div>

            <div *ngIf="!isLoadingNotes && notes.length === 0" class="no-response-state" style="padding:24px 0;">
              <mat-icon>chat_bubble_outline</mat-icon>
              <p>No notes yet. Add the first note above.</p>
            </div>

            <div *ngIf="!isLoadingNotes && notes.length > 0" class="notes-list">
              <div *ngFor="let note of notes" class="note-item">
                <div class="note-item-avatar">
                  {{ (note.createdByName || 'U').charAt(0).toUpperCase() }}
                </div>
                <div class="note-item-body">
                  <div class="note-item-header">
                    <span class="note-author">{{ note.createdByName || 'Unknown' }}</span>
                    <span class="note-timestamp">{{ formatHistoryDate(note.createdOn) }}</span>
                  </div>
                  <div class="note-text">{{ note.noteText }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- ── Right: Audit Trail ── -->
          <div class="audit-panel">
            <div class="notes-panel-title"><mat-icon>manage_search</mat-icon> Audit Trail</div>

            <div *ngIf="isLoadingHistory" class="loading-state" style="padding:24px 0;">
              <div class="spinner-lg"></div>
              <p>Loading audit trail...</p>
            </div>

            <div *ngIf="!isLoadingHistory && historyRecords.length === 0" class="no-response-state" style="padding:24px 0;">
              <mat-icon>history</mat-icon>
              <p>No verification activity recorded yet.</p>
            </div>

            <div *ngIf="!isLoadingHistory && historyRecords.length > 0" class="audit-trail">
              <div *ngFor="let rec of historyRecords; let last = last" class="audit-item">
                <div class="audit-line-wrap">
                  <div class="audit-dot" [class]="getHistoryStatusClass(rec.fileStatus)"></div>
                  <div *ngIf="!last" class="audit-connector"></div>
                </div>
                <div class="audit-body">
                  <div class="audit-action">
                    <mat-icon style="font-size:14px;height:14px;width:14px;color:#4a90d9;vertical-align:middle;">verified</mat-icon>
                    Waystar verification run
                  </div>
                  <div class="audit-detail">
                    <span class="audit-carrier">{{ rec.carrierName || '—' }}</span>
                    <span [class]="getHistoryStatusClass(rec.fileStatus)" style="font-size:10px;padding:1px 6px;">
                      {{ rec.fileStatus === '1' ? 'Active' : (rec.fileStatus || '—') }}
                    </span>
                    <span *ngIf="rec.inquiryId" class="audit-inquiry">Inquiry #{{ rec.inquiryId }}</span>
                  </div>
                  <div class="audit-timestamp">
                    <mat-icon style="font-size:11px;height:11px;width:11px;vertical-align:middle;">schedule</mat-icon>
                    {{ formatHistoryDate(rec.verifiedOn) }}
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div *ngIf="activeSection === 'Manual Call Workflow' ||
                  activeSection === 'Authorization'"
           class="placeholder-section">
        <mat-icon class="placeholder-icon">construction</mat-icon>
        <h3>{{ activeSection }}</h3>
        <p>This section is under construction.</p>
      </div>

    </div>
  </div>

  <!-- ══════════════════════════════════════════════
       FULL-SCREEN PAYER PICKER (search + chip results)
  ══════════════════════════════════════════════ -->
  <div *ngIf="showPayerPicker" class="payer-picker-overlay" (click)="closePayerPicker()">
    <div class="payer-picker-modal" (click)="$event.stopPropagation()">

      <!-- Header -->
      <div class="payer-picker-head">
        <div class="payer-picker-title">
          <mat-icon>account_balance</mat-icon>
          <span>Select Payer</span>
        </div>
        <button type="button" class="payer-picker-close" (click)="closePayerPicker()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <!-- Search + controls -->
      <div class="payer-picker-searchbar">
        <mat-icon>search</mat-icon>
        <input #payerPickerInput type="text" placeholder="Search payers by name or ID…"
               (input)="filterPayers(payerPickerInput.value)">
        <button type="button" class="payer-picker-searchclear" *ngIf="payerPickerInput.value"
                (click)="payerPickerInput.value=''; filterPayers('')">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="payer-picker-controls">
        <button type="button" class="payer-picker-enroll" (click)="toggleEnrolledOnly()">
          <mat-icon>{{ enrolledOnly ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
          <span>Enrollment required only</span>
          <span class="payer-enroll-tag">Y</span>
        </button>
        <span class="payer-picker-count">
          {{ payerMatchCount | number }} payer{{ payerMatchCount === 1 ? '' : 's' }}
        </span>
      </div>

      <!-- Chip results -->
      <div class="payer-picker-body">
        <button *ngFor="let payer of filteredPayers" type="button"
                class="payer-chip"
                [class.selected]="payer.id === intakeForm.get('payerId')?.value"
                [class.test]="payer.isTest"
                [attr.title]="payer.name + ' (' + payer.id + ')'"
                (click)="selectPayerFromPicker(payer)">
          <span *ngIf="payer.isTest" class="test-payer-tag">TEST</span>
          <span *ngIf="payer.enroll === 'Y'" class="payer-enroll-tag" matTooltip="Enrollment required for this payer">Y</span>
          <span class="payer-chip-name" [innerHTML]="payer._hl"></span>
          <span class="payer-chip-id">{{ payer.id }}</span>
          <mat-icon *ngIf="payer.id === intakeForm.get('payerId')?.value" class="payer-chip-check">check_circle</mat-icon>
        </button>
        <div *ngIf="filteredPayers.length === 0" class="payer-picker-empty">
          <mat-icon>search_off</mat-icon>
          <p>No payers match your search.</p>
        </div>
      </div>

      <!-- Footer -->
      <div class="payer-picker-foot">
        <button type="button" class="payer-picker-clearbtn"
                *ngIf="intakeForm.get('payerId')?.value" (click)="clearPayerSelection()">
          <mat-icon>close</mat-icon> Clear selection
        </button>
        <span class="payer-picker-selected" *ngIf="getSelectedPayerName()">
          Selected: <strong>{{ getSelectedPayerName() }}</strong>
        </span>
        <span class="payer-picker-hint">Click a payer to select</span>
      </div>
    </div>
  </div>

  <!-- ══════════════════════════════════════════════
       COVERAGE-DISCOVERY COST CONFIRM MODAL
  ══════════════════════════════════════════════ -->
  <div *ngIf="showCoverageCostConfirm" class="cost-confirm-overlay" (click)="cancelCoverageConfirm()">
    <div class="cost-confirm-modal" (click)="$event.stopPropagation()">
      <div class="cost-confirm-header">
        <mat-icon class="cost-confirm-icon">warning_amber</mat-icon>
        <div>
          <h3>Confirm Coverage Discovery</h3>
          <div class="cost-confirm-subtitle">This run will be billed at <strong>$4.50</strong></div>
        </div>
      </div>

      <div class="cost-confirm-body">
        <p>
          You've already selected a payer (<strong>{{ getSelectedPayerName() || '—' }}</strong>).
          A standard Waystar Check with that payer costs <strong>$0.25</strong>.
        </p>
        <p class="cost-warn-line">
          Coverage Discovery costs <strong>$4.50</strong> — about <strong>18&times;</strong> more — and is
          intended for cases where the patient's insurance is unknown or can't be verified the normal way.
        </p>

        <label class="cost-reason-label">
          Reason for running Coverage Discovery <span class="req">*</span>
          <span class="cost-reason-sub">(captured for audit)</span>
        </label>
        <select [(ngModel)]="coverageConfirmReason" class="form-control cost-reason-select">
          <option value="">Select a reason…</option>
          <option value="eligibility-failed">Standard eligibility returned inactive / not found</option>
          <option value="supplemental">Looking for supplemental coverage</option>
          <option value="payer-uncertain">Patient's primary payer is uncertain</option>
          <option value="self-pay-check">Self-pay — confirming no hidden coverage</option>
          <option value="other">Other</option>
        </select>
      </div>

      <div class="cost-confirm-footer">
        <button class="intake-btn intake-btn-blue cost-confirm-primary"
                (click)="switchToWaystarFromConfirm()"
                [disabled]="!intakeForm.get('payerId')?.value">
          <span class="intake-btn-inner">
            <mat-icon>play_arrow</mat-icon>
            Run Waystar Check instead
            <span class="btn-cost-tag">$0.25</span>
          </span>
        </button>
        <button class="intake-btn intake-btn-warning"
                [disabled]="!coverageConfirmReason"
                (click)="confirmAndRunCoverage()">
          <span class="intake-btn-inner">
            Continue with Discovery
            <span class="btn-cost-tag btn-cost-tag-warn">$4.50</span>
          </span>
        </button>
        <button class="cost-confirm-cancel" (click)="cancelCoverageConfirm()">Cancel</button>
      </div>
    </div>
  </div>

  <!-- ── Full-screen source-document overlay (opened from the top-bar icon) ── -->
  <div *ngIf="showDocViewer" class="doc-fullscreen-overlay">
    <div class="doc-fullscreen-bar">
      <div class="doc-fullscreen-title">
        <mat-icon>description</mat-icon><span>Source Document</span>
      </div>
      <button mat-stroked-button class="doc-fullscreen-close" (click)="showDocViewer = false">
        <mat-icon>close</mat-icon> Close
      </button>
    </div>
    <div class="doc-fullscreen-body">
      <ngx-doc-viewer *ngIf="aiDocUrl" [url]="aiDocUrl" viewer="url"
                      style="width:100%;height:100%;"></ngx-doc-viewer>
      <div *ngIf="!aiDocUrl" class="intake-ai-empty">
        <mat-icon>insert_drive_file</mat-icon>
        <p>No document available to preview.</p>
      </div>
    </div>
  </div>
</div>
